import React from 'react';

import { Router, Link } from '@reach/router';

import Home from './screens/Home';
import Planification from './screens/Planification';
import PlanificationMultiple from './screens/PlanificationMultiple';
import CarnetAdresse from './screens/CarnetAdresse';
import MessageManuel from './screens/MessageManuel';
import Reglages from './screens/Reglages';
import Logs from './screens/Logs';
export default function App() {
  return (
    <Router>
      <Home path="/" />
      <Planification path="planification" />
      <PlanificationMultiple path="planifmultiple" />
      <CarnetAdresse path="carnetadresse" />
      <MessageManuel path="messagemanuel" />
      <Reglages path="reglages" />
      <Logs path="logs" />
    </Router>
  );
}
